import { useState, useCallback } from 'react';

/**
 * useImportStock
 *
 * Owns the Import Stock Transactions modal state:
 *   showImportStock  — whether the import modal is open
 *   importStockMsg   — error/status message shown inside the modal
 *   menuCommandResp  — the `resp.arg` payload from calc engine (stockImport command)
 *   btnClickSpinner  — loading spinner state inside the modal
 */
const useImportStock = () => {
  const [showImportStock, setShowImportStock] = useState(false);
  const [importStockMsg, setImportStockMsg] = useState('');
  const [menuCommandResp, setMenuCommandResp] = useState({});
  const [btnClickSpinner, setBtnClickSpinner] = useState(false);

  const openImportStock = useCallback(respArg => {
    setMenuCommandResp(respArg);
    setShowImportStock(true);
  }, []);

  const closeImportStock = useCallback(() => {
    setShowImportStock(false);
  }, []);

  return {
    showImportStock,
    setShowImportStock,
    importStockMsg,
    setImportStockMsg,
    menuCommandResp,
    setMenuCommandResp,
    btnClickSpinner,
    setBtnClickSpinner,
    openImportStock,
    closeImportStock,
  };
};

export default useImportStock;
